import React, { useEffect, useRef, useState } from 'react';
import Save from "../../assets/save.svg";
import AttachmentModalProps from "./AttachmentModalProps";
import { Modal } from 'flowbite-react';

export const RenderVideo = ({ media, file_obj, disabled, component, onRemove, isReplyMessage }: AttachmentModalProps) => {
    const modalRef = useRef<HTMLDivElement | null>(null);
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
    const [scale, setScale] = useState(1);
    const modalBodyClass = 'h-full p-0 w-full object-contain flex justify-center items-center overflow-auto';

    const openModal = (url: string) => {
        setSelectedVideo(url);
    };

    const closeModal = () => {
        setSelectedVideo(null);
        setScale(1);
    };

    // Закрытие по клику вне модального окна
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                closeModal();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {media && component({
                media: media, onClick: () => openModal(media.file),
                isReplyMessage: isReplyMessage
            })}
            {file_obj && component({
                file_obj: file_obj,
                disabled: disabled,
                onRemove: onRemove,
                isReplyMessage: isReplyMessage,
                onClick: () => openModal(file_obj.media_info.file)
            })}
            {/* Модальное окно на весь экран для картинок */}
            <Modal
                size={'6xl'}
                show={selectedVideo !== null}
                ref={modalRef}
                style={{
                    transformOrigin: '0 0'
                }}
                onClose={closeModal}>
                <Modal.Header
                    className={"w-full flex flex-[0_0_auto] overflow-hidden whitespace-pre-wrap break-word-only-long"}
                >
                    {media && media.original_name}
                    {file_obj && file_obj.media_info.original_name}
                </Modal.Header>
                <Modal.Body
                    className={modalBodyClass}
                    style={{
                        transformOrigin: '0 0'
                    }}
                >
                    <video
                        src={selectedVideo || ''}
                        autoPlay={true}
                        controls={true}
                        style={{
                            transform: `scale(${scale})`,
                            transformOrigin: '0 0',
                            width: 'auto',
                            height: 'auto',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            position: 'relative',
                        }}
                        className="max-h-[75vh] max-w-[80vw] object-contain"
                    />
                </Modal.Body>
                <Modal.Footer className="w-full flex flex-[0_0_auto]">
                    <div className="flex w-full justify-center gap-2">
                        <a
                            className="w-10 p-2 flex flex-row justify-center items-center gap-1 text-black rounded-lg bg-melon-yellow hover:bg-yellow-400"
                            href={media?.file || file_obj?.media_info.file}
                            target={'_blank'}
                        >
                            <img src={Save} alt="download file" />
                        </a>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}
